export default __webpack_public_path__ + "static/media/Visa_Brandmark_Blue_RGB_2021.a05453b4.png";